module.exports = "/static/js/e72eea5e907931809614b1330f6a9397.png";